export default "__VITE_ASSET__CJDf4Mbq__"